import { render, staticRenderFns } from "./permissionListForm.vue?vue&type=template&id=4b175b42&scoped=true&"
import script from "./permissionListForm.vue?vue&type=script&lang=ts&"
export * from "./permissionListForm.vue?vue&type=script&lang=ts&"
import style0 from "./permissionListForm.vue?vue&type=style&index=0&id=4b175b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b175b42",
  null
  
)

export default component.exports